import { TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '../../../icons/SearchIcon.jsx';
import { Autocomplete } from '@material-ui/lab';
import debounce from 'lodash.debounce';
import React, { useState, useEffect, useMemo } from 'react';
import { getFullName } from '../../../utils';

const SearchComponent = ({
  value,
  setValue,
  searchApi,
  className,
  placeholder,
  label,
  required,
  disabled,
  responseKey,
  setUsers,
  setLoader,
  setEmpty,
}) => {
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const changeHandler = async (value) => {
    if (setLoader) {
      setLoader(true);
    }
    const query = await searchApi({ query: value });
    const optionsToSet = query?.[responseKey] ? query[responseKey] : query;
    setSearchOptions(optionsToSet || []);
    if (setLoader) {
      setLoader(false);
    }
    setLoading(false);
  };

  const debouncedChangeHandler = useMemo(
    () => debounce(changeHandler, 1000),
    []
  );

  useEffect(() => {
    return () => {
      debouncedChangeHandler.cancel();
    };
  }, []);

  useEffect(() => {
    if (inputValue === '') {
      debouncedChangeHandler.cancel();
      setLoading(false);
      setSearchOptions([]);
      if (setUsers) {
        setUsers('');
      }
    } else if (!value) {
      setLoading(true);
      debouncedChangeHandler(inputValue);
    }
  }, [inputValue]);

  return (
    <Autocomplete
      disabled={disabled}
      className={className}
      options={searchOptions}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        const name = getFullName(option.referredUserDetail);
        return `${
          option.referredUserDetail
            ? name
            : getFullName(option.User ? option.User : option)
        } | ${
          option.referredUserDetail
            ? option.referredUserDetail.email
            : option.email
        }`;
      }}
      value={value}
      onChange={(e, newValue) => {
        if (!newValue) setValue(null);
        if (newValue !== null && setUsers) {
          setUsers(newValue.id || '');
        }
        setValue(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(e, newValue) => {
        setEmpty && newValue === '' && setEmpty();
        setInputValue(newValue);
      }}
      filterOptions={(options) => options}
      getOptionSelected={(option, value) => option.userId === value.userId}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          label={label}
          variant='outlined'
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchComponent;
